import { Buffer } from 'buffer';
import { add, differenceInDays, format } from 'date-fns';
import moment from 'moment';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Col, Container, FlexboxGrid, Loader, Notification } from 'rsuite';

import { getCookie } from '../../../../services/CookiesService';
import { getFree } from '../../../../services/FreemiumService';
import { getClienteCompleto } from '../../../../services/UsuarioService';
import * as PainelGeralService from './services';

import {
  getBoxPlotData,
  getItensFiltro,
  getMapData,
  getMarkersData,
  getProductDashboardSlide,
  getProductDashboardTable,
  getShareTokenData,
  getTimeEvolutionData,
  getTopFiveData,
  getTotalDatapoints,
  searchProdutos,
  setErro,
  setLimitProducts,
  setPainelGeralState,
  setSortColumnBoxplot,
} from '../../../../actions/actionsPainelGeral';

import { LoadingSpinerArea } from '../../../../components/LoadingSpinner';
import ModalConfirm from '../../../../components/ModalConfirm';
import ModalNotification from '../../../../components/ModalNotification';
import AnalisysCounter from './Components/AnalisysCounter/AnalisysCounter';
import ChartsArea from './Components/ChartsArea';
import EmptyState from './Components/EmptyState';
import FiltersArea from './Components/FiltersArea';
import FixedBanner from './Components/FixedBanner';
import Header from './Components/Header';
import { ModalAnalisysPlan } from './Components/ModalAnalisysPlan';
import ModalBanner from './Components/ModalBanner';
import { ModalNoDetailsProducts } from './Components/ModalNoDetailsProducts';
import ModalPreviewDownload from './Components/ModalPreviewDownload';
import ModalShareAnalyzedViews from './Components/ModalShareAnalyzedViews';
import PanelPlanTags from './Components/PanelPlanTags';
import { PanelProductSliderArea } from './Components/PanelProductSliderArea';
import { ResultsButtonArea } from './Components/ResultsButtonArea';
import { WarningProductsOutOfList } from './Components/WarningProductsOutOfList';

import greenCheckIcon from '../../../../assets/icons/icon_check_circle_green.svg';
import noFilterImage from '../../../../assets/image/empty-state-1.svg';
import emptyStateImage from '../../../../assets/image/empty-state-3.svg';
import noResultsImage from '../../../../assets/image/empty-state-4.svg';

import { INFOPANEL_CTA_LINK } from '../../../../utils/constants';
import { fileDownloadStatus } from './data';

import { NotificationMessage } from '../../../../components';
import { trackEvent } from '../../../../utils/MatomoConfig';
import {
  disabledColumns,
  filterColumnsShoppingBrasil,
  getGroupBy,
  getMapComponentData,
  getModelDashboards,
  getModelPanel,
  getModelProduct,
  getModelProdutoRede,
  getOrder,
  getUserPlanType,
  isShoppingBrasilColumn,
  sendLead,
  setNameAttr,
  shoppingBrasilList,
} from './utils';

class InfoPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      usuario: null,
      errors: {},
      columns: [],
      showModalDownload: false,
      showModalTrial: false,
      showPainel: false,
      showWarningNoGtin: false,
      showWarningToMuchProducts: false,
      showModalProdutosSemDetalhes: false,
      visulizationTime: 0,
      showBanner: false,
      freeData: null,
      showModalShareAnalyzedViews: false,
      fileDownloadStatusType: 'willReceiveByEmail',
      showMoreProductsSelected: false,
      timer: null,
      productQueryValue: '',
    };

    this.validDateInput = this.validDateInput.bind(this);
    this.getDownloadData = this.getDownloadData.bind(this);
    this.getIframe = this.getIframe.bind(this);
    this.close = this.close.bind(this);
    this.handleChangeColumn = this.handleChangeColumn.bind(this);
    this.handleCheckAllColumn = this.handleCheckAllColumn.bind(this);
    this.getPreview = this.getPreview.bind(this);
    this.confirmDowload = this.confirmDowload.bind(this);
    this.setDataViewFree = this.setDataViewFree.bind(this);
    this.getShareTokensModal = this.getShareTokensModal.bind(this);
    this.handleCopyLink = this.handleCopyLink.bind(this);
    this.analysisDeadline = this.analysisDeadline.bind(this);
    this.handleSendShareAnalysisLink = this.handleSendShareAnalysisLink.bind(this);
    this.mapColumnsByContract = this.mapColumnsByContract.bind(this);
    this.handleShowMoreProductsSelected = this.handleShowMoreProductsSelected.bind(this);
    this.handleSearchFilter = this.handleSearchFilter.bind(this);
    this.handleFilterProduto = this.handleFilterProduto.bind(this);
    this.handleOnOpenProduto = this.handleOnOpenProduto.bind(this);
    this.handleChangeMapProduct = this.handleChangeMapProduct.bind(this);
    this.handleCleanMapProduct = this.handleCleanMapProduct.bind(this);
    this.handleOnSelectTopFiveFilter = this.handleOnSelectTopFiveFilter.bind(this);
    this.handleVisualizationTimeEvolutionFilters = this.handleVisualizationTimeEvolutionFilters.bind(this);
    this.handleOnCleanTimeEvolution = this.handleOnCleanTimeEvolution.bind(this);
    this.handleOnCleanTopFiveProduct = this.handleOnCleanTopFiveProduct.bind(this);
    this.handleOnChangeVisualizationBoxplot = this.handleOnChangeVisualizationBoxplot.bind(this);
    this.handleOnChangeVisualizationTimeEvolution = this.handleOnChangeVisualizationTimeEvolution.bind(this);
    this.handleOnChangeVisualizationMap = this.handleOnChangeVisualizationMap.bind(this);
    this.handleOnClickProductDashboardDownload = this.handleOnClickProductDashboardDownload.bind(this);
    this.handleBoxplotDownload = this.handleBoxplotDownload.bind(this);
    this.productDashboardDownloadService = this.productDashboardDownloadService.bind(this);
    this.handleOnClickLoadMoreProduto = this.handleOnClickLoadMoreProduto.bind(this);
    this.handleOnClickProductDashboardTablePage = this.handleOnClickProductDashboardTablePage.bind(this);
    this.handleOnCancelModalAnalisysPlan = this.handleOnCancelModalAnalisysPlan.bind(this);
    this.sendCTA = this.sendCTA.bind(this);
  }

  componentDidMount() {
    const { produto } = this.props;
    this.getUserInformation();
  }

  shouldComponentUpdate(nextProps, nextState) {
    const {
      boxplotType,
      filtros,
      filtrosAdicionados,
      timeEvolutionPeriodo,
      timeEvolutionType,
      usuario,
      produto,
      rede,
      tipoLoja,
      cnpj,
      fabricante,
      marca,
      conteudo,
      tipoProduto,
      secao,
      categoria,
      mecanica,
      grupoMidia,
      midia,
      uf,
      cidade,
      endereco,
      regiao,
      tipoPreco,
      origemPreco,
      pmc,
      rebaixaPreco,
      marcaPropria,
      raio,
      preco,
      canal,
      productDashboardList,
      productsWithoutUnitMeasurement,
    } = this.props;

    return (
      nextProps !== boxplotType ||
      nextProps !== filtros ||
      nextProps !== filtrosAdicionados ||
      nextProps !== timeEvolutionPeriodo ||
      nextProps !== timeEvolutionType ||
      nextProps !== usuario ||
      nextProps !== produto ||
      nextProps !== rede ||
      nextProps.tipoLoja !== tipoLoja ||
      nextProps.cnpj !== cnpj ||
      nextProps.fabricante !== fabricante ||
      nextProps.marca !== marca ||
      nextProps.conteudo !== conteudo ||
      nextProps.tipoProduto !== tipoProduto ||
      nextProps.secao !== secao ||
      nextProps.categoria !== categoria ||
      nextProps.mecanica !== mecanica ||
      nextProps.grupoMidia !== grupoMidia ||
      nextProps.midia !== midia ||
      nextProps.uf !== uf ||
      nextProps.cidade !== cidade ||
      nextProps.endereco !== endereco ||
      nextProps.regiao !== regiao ||
      nextProps.tipoPreco !== tipoPreco ||
      nextProps.origemPreco !== origemPreco ||
      nextProps.pmc !== pmc ||
      nextProps.rebaixaPreco !== rebaixaPreco ||
      nextProps.marcaPropria !== marcaPropria ||
      nextProps.raio !== raio ||
      nextProps.preco !== preco ||
      nextProps.canal !== canal ||
      nextProps.productDashboardList !== productDashboardList ||
      nextProps.productsWithoutUnitMeasurement !== productsWithoutUnitMeasurement ||
      nextState !== this.state
    );
  }

  handleChangeColumn(value) {
    const { allValue } = this.state;

    this.setState({
      columnsValue: value,
      indeterminateColumn: value.length > 0 && value.length < allValue.length,
      checkAllColumn: value.length === allValue.length,
    });
  }

  mapColumnsByContract(columns, selectAll) {
    const { usuario } = this.props;
    const hasCookieList = getCookie('colunasPanel')?.length > 1;
    const isUserSB = usuario?.tipoAdicionalContratos.PAN.includes('SB');

    if (!selectAll && hasCookieList) {
      return getCookie('colunasPanel');
    }

    if (!isUserSB) {
      return filterColumnsShoppingBrasil(columns).map(item => item.name);
    }
    return columns.map(item => item.name);
  }

  handleCheckAllColumn(value, checked) {
    const { columns } = this.state;
    const nextValue = checked
      ? this.mapColumnsByContract(columns, checked)
      : columns.map(item => item.name).filter(item => item === 'DATA_PRECO' || item === 'GTIN' || item === 'CNPJ');

    this.setState({
      columnsValue: nextValue,
      indeterminateColumn: false,
      checkAllColumn: checked,
    });
  }

  getUserInformation() {
    getClienteCompleto(JSON.parse(localStorage.getItem('usuario'))?.email).then(response => {
      if (response) {
        if (response?.servicoPanel?.pacotePainel?.name === 'FREE') {
          this.getConfigFree(response);
          this.getContratoLimiteData(response?.login);
        }
        this.setState({ usuario: response }, this.getColumns);
      }
    });
  }

  getConfigFree() {
    getFree().then(response => {
      this.setState({
        freeData: response,
      });
    });
  }

  getColumns() {
    PainelGeralService.getColumnsExportFile().then(data => {
      if (data?.length) {
        this.setColumns(data);
      }
    });
  }

  setCookieColumn(colunas) {
    const colunasJoin = colunas.join(',');
    const expires = moment().add(365, 'days').toDate();
    document.cookie = `colunasPanel=${colunasJoin};expires=${expires.toUTCString()};path=/`;

    this.setState({
      columnsValue: colunas,
    });
  }

  setColumns(columns) {
    this.setState({
      columns: columns.map(item => ({
        id: item.name,
        value: item.name,
        label: item.description,
        column: item.column,
        name: item.name,
        descricao: item.description,
        obrigatorio: item.required,
      })),
      columnsValue: this.mapColumnsByContract(columns),
    });
  }

  setDataProductsCards() {
    const { produto } = this.props;

    this.setState({
      productsSelected: produto.cache,
    });
  }

  getDataDashboard() {
    this.setState({
      showPainel: true,
      showWarningNoGtin: false,
      showWarningToMuchProducts: false,
    });
  }

  setNoGtinState() {
    this.setState({
      showPainel: true,
      showWarningNoGtin: true,
    });
  }

  setToMuchProductsState() {
    this.setState({
      showPainel: true,
      showWarningToMuchProducts: true,
    });
  }

  setDataView(page) {
    const {
      getTimeEvolutionData,
      timeEvolutionType,
      timeEvolutionPeriodo,
      mapType,
      getTopFiveData,
      getProductDashboardSlide,
      getProductDashboardTable,
      produto,
    } = this.props;
    const { usuario, showMoreProductsSelected } = this.state;

    if (usuario?.servicoPanel?.pacotePainel?.name === 'FREE') {
      this.setDataViewFree();
    } else if (usuario?.servicoPanel?.pacotePainel?.name === 'LIMIT') {
      this.setDataViewLimit();
    } else {
      getMapComponentData(mapType, this.props, '');
      getTimeEvolutionData(getModelDashboards(this.props), {
        type: timeEvolutionType,
        periodo: timeEvolutionPeriodo,
      });
      getTopFiveData(getModelDashboards(this.props));
      this.getDadosBoxPlot();
      this.setDataProductsCards();
      this.getDataDashboard();
    }

    if (showMoreProductsSelected) {
      getProductDashboardTable(
        { filter: getModelDashboards(this.props) },
        {
          page: 0,
          size: 10,
        },
        'table',
      );
    } else {
      getProductDashboardSlide(
        { filter: getModelDashboards(this.props) },
        {
          page: null,
          size: produto?.value?.length,
        },
        'slide',
      );
    }
  }

  setDataViewFree() {
    const { getTimeEvolutionData, timeEvolutionType, timeEvolutionPeriodo, boxplotType, getTopFiveData } = this.props;

    if (timeEvolutionType !== 'rede' && timeEvolutionType !== 'fabricante') {
      getTimeEvolutionData(getModelDashboards(this.props), {
        type: timeEvolutionType,
        periodo: timeEvolutionPeriodo,
      });
    }

    if (boxplotType !== 'rede' && boxplotType !== 'produtoRede' && boxplotType !== 'fabricante') {
      this.getDadosBoxPlot();
    }

    getTopFiveData(getModelDashboards(this.props));
    this.setDataProductsCards();
    this.getDataDashboard();
  }

  setDataViewLimit() {
    const { getTimeEvolutionData, timeEvolutionType, timeEvolutionPeriodo, boxplotType, getTopFiveData, mapType, produto } = this.props;

    if (
      ((timeEvolutionType === 'rede' || timeEvolutionType === 'fabricante') && produto?.cache.every(item => item.limited === false)) ||
      (timeEvolutionType !== 'rede' && timeEvolutionType !== 'fabricante')
    ) {
      getTimeEvolutionData(getModelDashboards(this.props), {
        type: timeEvolutionType,
        periodo: timeEvolutionPeriodo,
      });
    }

    if (
      ((boxplotType === 'rede' || boxplotType === 'produtoRede' || timeEvolutionType === 'fabricante') &&
        produto?.cache.every(item => item.limited === false)) ||
      (boxplotType !== 'rede' && boxplotType !== 'produtoRede' && timeEvolutionType !== 'fabricante')
    ) {
      this.getDadosBoxPlot();
    }

    if (produto?.cache?.every(item => item.limited === false)) {
      getMapComponentData(mapType, this.props, '');
    }

    getTopFiveData(getModelDashboards(this.props));
    this.setDataProductsCards();
    this.getDataDashboard();
  }

  getIframe(page) {
    const { produto, getTotalDatapoints, userContratoLimiteData, setPainelGeralState } = this.props;
    const { usuario } = this.state;
    const isFree = usuario?.servicoPanel?.pacotePainel?.name === 'FREE';
    const hasNoAnalisysAvailable = userContratoLimiteData?.limiteDisponivel === 0;

    if (this.validDateInput()) {
      this.setColumnsPreview();
      this.countVisualization();
      trackEvent('InfoPanel', 'Visualizar');

      if (produto?.cache?.length && produto.cache.length <= 120) {
        this.setDataView(page);
      } else if (produto?.cache?.length && produto.cache.length > 120) {
        this.setToMuchProductsState();
      } else {
        this.setNoGtinState();
      }

      if (isFree) {
        if (hasNoAnalisysAvailable) {
          setPainelGeralState('showModalAnalisysPlan', true);
        } else {
          getTotalDatapoints(getModelPanel(this.props));

          setTimeout(() => {
            this.getContratoLimiteData(usuario?.login);
          }, 1000);
        }
      } else {
        getTotalDatapoints(getModelPanel(this.props));
      }
    }
  }

  setColumnsPreview() {
    const { usuario } = this.props;
    const { columns, columnsValue } = this.state;
    const isUserSB = usuario?.tipoAdicionalContratos.PAN.includes('SB');
    const newColumnList = [];
    const newColumnsValue = [];
    const preview = [];

    if (!isUserSB) {
      const noSBColumnList = columns?.filter(item => !shoppingBrasilList.includes(item.id));
      const noSBColumnsValue = columnsValue?.filter(item => !shoppingBrasilList.includes(item));
      newColumnList.push(...noSBColumnList);
      newColumnsValue.push(...noSBColumnsValue);
    } else {
      newColumnList.push(...columns);
      newColumnsValue.push(...columnsValue);
    }

    newColumnList.forEach(column => {
      if (columnsValue?.findIndex(item => column.name === item) !== -1) {
        preview.push(column);
      }
    });

    this.setState({
      allValue: newColumnList && newColumnList?.map(item => item.name),
      columnsPreview: preview?.length ? preview : newColumnList,
      checkAllColumn: newColumnsValue?.length === newColumnList?.length,
      columnsValue: newColumnsValue?.length ? newColumnsValue : this.mapColumnsByContract(newColumnList),
    });
  }

  getDadosBoxPlot(type, page, size) {
    const { setSortColumnBoxplot, getBoxPlotData, boxplotType } = this.props;
    const pagination = { page: page || 0, size: size || 10 };

    setSortColumnBoxplot(null);
    getBoxPlotData(getModelDashboards(this.props), boxplotType, pagination);
  }

  isTotalDatapointsValid(totalDatapoints) {
    if (totalDatapoints > 1000000) {
      this.setState({
        showModalDownload: true,
        fileDownloadStatusType: 'willNotDownload',
      });
      return false;
    }
    if (totalDatapoints === 0) {
      this.setState({
        showModalDownload: true,
        fileDownloadStatusType: 'noDataForDownload',
      });
      return false;
    }
    return true;
  }

  getPreview(extension) {
    if (this.isTotalDatapointsValid(this.props.totalDatapoints)) {
      this.setColumnsPreview();

      PainelGeralService.getColumnsPreview().then(data => {
        this.setState({
          extension,
          itensPreview: data,
          showModalPreviewDownloadPanel: true,
        });
      });
    }
  }

  getDownloadData() {
    const { filtroSalvo, extension, columnsValue, usuario } = this.state;

    if (this.validDateInput()) {
      if (usuario?.servicoPanel?.trial) {
        this.setState({
          showModalTrial: true,
        });
      }

      trackEvent('InfoPanel', 'Download');
      const model = getModelPanel(this.props);
      model.filtroSalvo = filtroSalvo;
      model.extensao = extension;
      model.dimensoes = columnsValue.filter(item => item !== 'TIPO_PRECO');

      PainelGeralService.painelDownload(model).then(data => {
        if (data && data.status === 202) {
          const responseData = JSON.parse(Buffer.from(data.data).toString('utf8'));
          let downloadStatus;

          if (responseData.totalElements < 300_000) {
            downloadStatus = 'willReceiveByEmail';
          }
          if (responseData.totalElements > 300_000 && responseData.totalElements < 1_000_000) {
            downloadStatus = 'willDelay';
          }
          this.setState({
            showModalDownload: true,
            fileDownloadStatusType: downloadStatus,
          });
        }
      });
    }
  }

  confirmDowload() {
    this.setState(
      {
        showModalPreviewDownloadPanel: false,
      },
      this.getDownloadData,
    );
  }

  validDateInput() {
    const { errors, usuario } = this.state;
    const { filtrosAdicionados, setErro, produto, dataInicio, dataFim, raio, endereco, rede } = this.props;

    const data = document.getElementsByName('data')[0];
    let formIsValid = true;

    const data1 = dataInicio ? moment(dataInicio).format() : null;
    const data2 = dataFim ? moment(dataFim).format() : null;
    const diff = dataInicio ? moment(data2).diff(moment(data1), 'days') + 1 : null;

    if (!dataInicio) {
      formIsValid = false;
      this.setState({ errors: { data: 'Campo obrigatório' } });
      if (data) {
        data.classList.add('filtros__input_invalid');
      }
    } else if (dataInicio && diff < 7) {
      formIsValid = false;
      this.setState({
        errors: {
          data: 'O intervalo mínimo para a seleção de data deve ser de 7 dias',
        },
      });
      if (data) {
        data.classList.add('filtros__input_invalid');
      }
    } else {
      this.setState({ errors: { data: null } });
      if (data) {
        data.classList.remove('filtros__input_invalid');
      }
    }

    const enderecoElement = document.getElementsByName('endereco')[0];
    if (filtrosAdicionados?.findIndex(filtro => filtro.name === 'endereco') !== -1 && raio.value && !endereco.value.length) {
      formIsValid = false;
      setErro('Para definir um raio, você deve definir também um endereço', 'endereco');
      if (enderecoElement) {
        enderecoElement.classList.add('invalid-input');
      }
    } else {
      setErro(null, 'endereco');
      if (enderecoElement) {
        enderecoElement.classList.remove('invalid-input');
      }
    }

    const redeElement = document.getElementsByName('rede')[0];
    if (usuario?.servicoPanel?.pacotePainel?.name === 'LIMIT' && rede.value.length && produto?.cache?.some(item => item.limited === true)) {
      formIsValid = false;
      setErro('Não é possível fazer filtro de rede para produtos sem acesso completo', 'rede');
      if (redeElement) {
        redeElement.classList.add('invalid-input');
      }
    } else {
      setErro(null, 'rede');
      if (redeElement) {
        redeElement.classList.remove('invalid-input');
      }
    }

    return formIsValid;
  }

  confirmColumns() {
    const { columns, columnsValue } = this.state;
    const preview = [];

    columns.forEach(coluna => {
      if (columnsValue?.findIndex(item => coluna.name === item) !== -1) {
        preview.push(coluna);
      }
    });

    this.setState({
      columnsPreview: preview,
    });

    this.setCookieColumn(columnsValue);
  }

  clearVisualizationTime() {
    this.setState({
      visulizationTime: 0,
    });
  }

  showFreemiumBanner() {
    const { visulizationTime } = this.state;

    if (visulizationTime > 2) {
      this.setState(
        {
          showBanner: true,
        },
        this.clearVisualizationTime,
      );
    }
  }

  countVisualization() {
    const { visulizationTime, usuario } = this.state;

    if (usuario?.servicoPanel?.pacotePainel?.name === 'FREE') {
      this.setState(
        {
          visulizationTime: visulizationTime + 1,
        },
        this.showFreemiumBanner,
      );
    }
  }

  close(stateName) {
    this.setState({
      [stateName]: false,
    });
  }

  getShareTokensModal() {
    const { usuario } = this.state;
    const { getShareTokenData, boxplotType, timeEvolutionPeriodo, timeEvolutionType, mapType, produto } = this.props;

    const chartsData = {
      timeEvolution: {
        type: timeEvolutionType,
        periodo: timeEvolutionPeriodo,
      },
      boxplot: {
        type: boxplotType,
      },
      map: {
        type: mapType,
      },
    };

    const teType = timeEvolutionType === 'rede' || timeEvolutionType === 'fabricante';
    const bpType =
      boxplotType === 'rede' || boxplotType === 'produtoRede' || boxplotType === 'uf' || boxplotType === 'produtoUF' || boxplotType === 'fabricante';

    const plan = usuario?.servicoPanel?.pacotePainel?.name === 'FREE' || usuario?.servicoPanel?.pacotePainel?.name === 'LITE';
    const limit = usuario?.servicoPanel?.pacotePainel?.name === 'LIMIT' && produto?.cache.some(item => item.limited === true);

    const mapLimit = mapType === 'loja' && limit;

    if (((teType || bpType) && (plan || limit)) || mapLimit) {
      Notification.error({
        title: 'Compartilhamento negado',
        description: 'Verifique o tipo de plano ou permissão a visualizações de cada gráfico',
      });
    } else {
      getShareTokenData(getModelDashboards(this.props), chartsData);
      this.setState({
        showModalShareAnalyzedViews: true,
      });
    }
  }

  handleCopyLink() {
    const { shareTokens } = this.props;

    const concatURL = `https://app.infoprice.co/share-analyze/#${shareTokens?.data}`;
    navigator.clipboard.writeText(concatURL);
    trackEvent('InfoPanel', 'click-compartilhar-relatorio');
  }

  analysisDeadline() {
    const { dataInicio } = this.props;
    const date = new Date();
    const today = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0);
    const ninetyDaysBeforeFromToday = add(today, { days: -91 });
    const filterInitialDate = dataInicio;
    const diffDays = differenceInDays(filterInitialDate, ninetyDaysBeforeFromToday);

    if (diffDays <= 6) {
      const calcDeadline = add(today, { days: diffDays });
      return format(calcDeadline, 'dd/MM/yyyy');
    }
    return null;
  }

  handleSendShareAnalysisLink(data) {
    const { shareTokens } = this.props;

    const concatURL = `https://app.infoprice.co/share-analyze/#${shareTokens.data}`;

    const emailData = {
      emails: data.emails,
      message: data.message,
      link: concatURL,
    };

    PainelGeralService.sendShareAnalysisEmail(emailData).then(() => {
      Notification.success({
        title: 'Análise compartilhada!',
        description: 'Visualização de análise compartilhada com sucesso!',
      });
      this.setState({
        showModalShareAnalyzedViews: false,
      });
    });
  }

  handleShowMoreProductsSelected(show) {
    const { getProductDashboardTable, getProductDashboardSlide, produto } = this.props;
    this.setState(prevState => ({
      showMoreProductsSelected: !prevState.showMoreProductsSelected,
    }));

    if (produto.cache.length <= 120) {
      if (show) {
        getProductDashboardTable(
          { filter: getModelDashboards(this.props) },
          {
            page: 0,
            size: 10,
          },
          'table',
        );
      } else {
        getProductDashboardSlide(
          { filter: getModelDashboards(this.props) },
          {
            page: null,
            size: produto?.value?.length,
          },
          'slide',
        );
      }
    }
  }

  handleSearchFilter(searchTerm, filter) {
    const normalize = v => v.replace(/^0+/, '');

    const { getItensFiltro, setPainelGeralState, cnpj } = this.props;
    const { timer } = this.state;
    let query;

    if (searchTerm && typeof searchTerm === 'string' && searchTerm.match(/^\d+ \d+[\d+ ]*$/) && filter.name === 'cnpj') {
      if (searchTerm.split(' ').length > 1000) {
        NotificationMessage('error', 5000, 'É possível selecionar até 1000 CNPJs');
        return;
      }
      query = searchTerm.split(' ');

      setPainelGeralState('cnpj', {
        ...cnpj,
        value: [...cnpj.value.map(normalize), ...query.map(normalize)],
      });
    } else {
      query = typeof searchTerm === 'string' ? searchTerm : '';
    }

    clearTimeout(timer);
    const newTimer = setTimeout(() => {
      getItensFiltro(getModelPanel(this.props, query, setNameAttr(filter.name)), filter.name, 'painel');
    }, 500);
    this.setState({
      timer: newTimer,
    });
  }

  handleFilterProduto(inputValue) {
    const { searchProdutos } = this.props;
    const { timer } = this.state;
    let filtros;

    if (inputValue && typeof inputValue === 'string' && inputValue.match(/^\d+ \d+[\d+ ]*$/)) {
      filtros = { query: '', identificadores: inputValue.split(' ') };
    } else {
      filtros = {
        query: typeof inputValue === 'string' ? inputValue : '',
      };
    }

    clearTimeout(timer);

    const newTimer = setTimeout(() => {
      searchProdutos(getModelPanel(this.props, filtros.query, 'produto', filtros.identificadores ? filtros.identificadores : null));
    }, 500);

    this.setState({
      timer: newTimer,
      productQueryValue: inputValue,
    });
  }

  handleOnOpenProduto() {
    const { searchProdutos } = this.props;
    this.setState({
      productQueryValue: '',
    });
    searchProdutos(getModelPanel(this.props, '', 'produto'));
  }

  handleOnClickLoadMoreProduto() {
    const { searchProdutos, produto } = this.props;
    const { productQueryValue } = this.state;
    const productListLength = produto?.lista.length;

    if (productListLength < 1000) {
      searchProdutos(getModelPanel(this.props, productQueryValue, 'produto'), productListLength + 100);
    }
  }

  handleChangeMapProduct(typeVisualization, identificador) {
    const { getMarkersData, getMapData } = this.props;
    const filters = getModelProduct(this.props, identificador);

    if (typeVisualization === 'loja') {
      getMarkersData(filters);
    } else {
      getMapData(filters);
    }
  }

  handleCleanMapProduct(typeVisualization) {
    const { getMarkersData, getMapData } = this.props;

    const filters = getModelDashboards(this.props);

    if (typeVisualization === 'loja') {
      getMarkersData(filters);
    } else {
      getMapData(filters);
    }
  }

  handleOnChangeVisualizationMap(typeVisualization, filteredProduct) {
    getMapComponentData(typeVisualization, this.props, filteredProduct);
  }

  handleOnSelectTopFiveFilter(filtroRede, filtroProduto) {
    const { getTopFiveData } = this.props;
    const filters = getModelProdutoRede(this.props, filtroProduto, filtroRede);

    getTopFiveData(filters);
  }

  handleOnCleanTopFiveProduct(filtroRede, filtroProduto) {
    const { getTopFiveData } = this.props;
    const filters = getModelProdutoRede(this.props, filtroProduto, filtroRede);

    getTopFiveData(filters);
  }

  handleOnChangeVisualizationBoxplot(typeVisualization, pagination, order) {
    const { getBoxPlotData } = this.props;
    getBoxPlotData(getModelDashboards(this.props), typeVisualization, pagination, order);
  }

  handleOnCleanTimeEvolution(filtroRede, filtroProduto, chartOptions) {
    const { getTimeEvolutionData } = this.props;
    const filters = getModelProdutoRede(this.props, filtroProduto, filtroRede);

    getTimeEvolutionData(filters, {
      type: chartOptions.typeVisualization,
      periodo: chartOptions.periodo,
    });
  }

  handleVisualizationTimeEvolutionFilters(filtroRede, filtroProduto, chartOptions) {
    const { getTimeEvolutionData } = this.props;
    const filters = getModelProdutoRede(this.props, filtroProduto, filtroRede);

    getTimeEvolutionData(filters, {
      type: chartOptions.typeVisualization,
      periodo: chartOptions.periodo,
    });
  }

  handleOnChangeVisualizationTimeEvolution(typeVisualization, periodo) {
    const { getTimeEvolutionData } = this.props;
    getTimeEvolutionData(getModelDashboards(this.props), {
      type: typeVisualization,
      periodo,
    });
  }

  handleBoxplotDownload(type, sortColumn, sortType, typeVisualization) {
    const data = {
      filter: getModelDashboards(this.props),
      group: getGroupBy(typeVisualization),
      order: sortColumn ? [{ by: sortColumn, ascending: sortType === 'asc' }] : getOrder(typeVisualization),
      options: {
        download: {
          extension: type,
        },
      },
    };

    PainelGeralService.downloadBoxplot(data).then(data => {
      if (data && data.status === 202) {
        this.setState({
          showModalDownload: true,
        });
      }
    });
  }

  async productDashboardDownloadService(data) {
    Notification.open({
      key: 'download-big-numbers',
      className: 'download-big-numbers',
      duration: 100000,
      description: (
        <>
          <Loader />
          <p>Download processando...</p>
        </>
      ),
    });
    const response = await PainelGeralService.productDashboardDownloadService(data);

    if (response.status === 200) {
      const blob = new Blob([response.data]);
      const hiddenElement = document.createElement('a');
      hiddenElement.href = window.URL.createObjectURL(blob);
      hiddenElement.target = '_blank';
      hiddenElement.download = `produto_dashboard.${data.options.download.extension}`;
      hiddenElement.click();

      Notification.close('download-big-numbers');
      Notification.open({
        key: 'download-big-numbers-success',
        className: 'download-big-numbers-success',
        duration: 5000,
        description: (
          <>
            <img src={greenCheckIcon} alt="" />
            <p>Download concluído</p>
          </>
        ),
      });
    } else {
      Notification.close('download-big-numbers');
      Notification.open({
        key: 'download-big-numbers-error',
        className: 'download-big-numbers-error',
        duration: 5000,
        description: <p>Ocorreu um erro!</p>,
      });
    }
  }

  handleOnClickProductDashboardDownload(type) {
    const data = {
      filter: getModelDashboards(this.props),
      options: {
        download: {
          extension: type,
        },
        top_k_results: {
          maximum_results: 10,
          columns: ['GTIN'],
        },
      },
    };
    this.productDashboardDownloadService(data);
  }

  handleOnClickProductDashboardTablePage(page) {
    const { getProductDashboardTable } = this.props;

    getProductDashboardTable(
      { filter: getModelDashboards(this.props) },
      {
        page: typeof page === 'number' ? page : 0,
        size: 10,
      },
      'table',
    );
  }

  handleOnCancelModalAnalisysPlan() {
    const { setPainelGeralState } = this.props;
    setPainelGeralState('showModalAnalisysPlan', false);
  }

  getContratoLimiteData(user) {
    const { setPainelGeralState } = this.props;

    PainelGeralService.getUserContratoLimiteService(user).then(resp => {
      if (resp.data?.limiteTotal) {
        setPainelGeralState('userContratoLimiteData', resp.data);
      }
    });
  }

  sendCTA() {
    const { setPainelGeralState } = this.props;
    const { usuario } = this.state;
    const identificador = 'upsell_infopanel';
    sendLead(usuario, identificador);
    setPainelGeralState('showModalAnalisysPlan', false);
    setPainelGeralState('showModalSpeakWithSpecialist', false);
    trackEvent('Upsell/Crossell', 'upsell-free-users');
    window.open(INFOPANEL_CTA_LINK);
  }

  renderNoGtinWarning() {
    return (
      <FlexboxGrid>
        <FlexboxGrid.Item colspan={24} componentClass={Col} xsHidden smHidden>
          <EmptyState
            title="Apenas o download dos resultados está disponível"
            message="Para visualizar as análises selecione até 120 produtos."
            image={emptyStateImage}
          />
        </FlexboxGrid.Item>
        <FlexboxGrid.Item colspan={24} componentClass={Col} lgHidden mdHidden>
          <EmptyState title="Ops! Gráficos não disponíveis" message="Para visualizar gráficos selecione um produto e tente novamente." image={noFilterImage} />
        </FlexboxGrid.Item>
      </FlexboxGrid>
    );
  }

  renderTooManyProductsWarning() {
    const { usuario } = this.state;
    const isFullPlan = usuario?.servicoPanel?.pacotePainel?.name === 'FULL';
    const title = isFullPlan ? 'Apenas o download dos resultados está disponível' : 'Visualização indisponível';

    return (
      <FlexboxGrid>
        <FlexboxGrid.Item colspan={24}>
          <EmptyState title={title} message="Para visualizar as análises selecione até 120 produtos." image={emptyStateImage} />
        </FlexboxGrid.Item>
      </FlexboxGrid>
    );
  }

  renderChartsArea() {
    const { usuario, productsSelected } = this.state;

    return (
      <ChartsArea
        usuario={usuario}
        productsSelected={productsSelected}
        onSelectTimeEvolution={this.handleVisualizationTimeEvolutionFilters}
        onCleanTimeEvolution={this.handleOnCleanTimeEvolution}
        onSelectTopFive={this.handleOnSelectTopFiveFilter}
        onCleanTopFive={this.handleOnCleanTopFiveProduct}
        onChangeMapProduct={this.handleChangeMapProduct}
        onCleanMapProduct={this.handleCleanMapProduct}
        onChangeVisualizationBoxplot={this.handleOnChangeVisualizationBoxplot}
        onChangeVisualizationTimeEvolution={this.handleOnChangeVisualizationTimeEvolution}
        onChangeVisualizationMap={this.handleOnChangeVisualizationMap}
        onClickDownload={this.handleBoxplotDownload}
        onClickSpeakWithSpecialist={this.sendCTA}
      />
    );
  }

  renderContentArea() {
    const { showWarningNoGtin, showWarningToMuchProducts } = this.state;

    if (showWarningNoGtin) {
      return this.renderNoGtinWarning();
    }

    if (showWarningToMuchProducts) {
      return this.renderTooManyProductsWarning();
    }

    return this.renderChartsArea();
  }

  renderPlanTags() {
    const { freeData, usuario } = this.state;
    const isFree = usuario?.servicoPanel?.pacotePainel?.name === 'FREE';

    if (!isFree && !freeData) return null;

    return <PanelPlanTags plan={freeData} />;
  }

  renderProductWarning() {
    const { usuario } = this.state;
    const { produto } = this.props;
    const isFlex = usuario?.servicoPanel?.pacotePainel?.name === 'FLEX';
    const isProductOutOfList = produto?.cache?.some(item => item.limited === true);

    if (!isFlex && !isProductOutOfList) return null;

    return (
      <WarningProductsOutOfList
        content={
          <>
            <span className="infopanel-warning-bold-text">Um ou mais produtos selecionados estão fora do seu contrato. </span>
            <span>Por isso, alguns resultados estarão restritos. </span>
          </>
        }
        onShowModal={() => {
          this.setState({ showModalProdutosSemDetalhes: true });
        }}
      />
    );
  }

  renderProductUnitMeasurementWarning = () => {
    const { showPainel } = this.state;
    const { productDashboardList, setPainelGeralState, productsWithoutUnitMeasurement } = this.props;

    const hasDatapoints = productDashboardList?.datapoints && productDashboardList?.datapoints?.length > 0;
    const showWarning = showPainel && hasDatapoints && productsWithoutUnitMeasurement?.length;

    if (showWarning)
      return (
        <WarningProductsOutOfList
          style={{ margin: '0 20px 20px 20px' }}
          content={
            <>
              <span className="infopanel-warning-bold-text">Um ou mais produtos selecionados não possuem preço por unidade de medida. </span>
              <span>Por isso, alguns resultados não serão mostrados nos gráficos. </span>
            </>
          }
          onShowModal={() => setPainelGeralState('showModalProductWithoutUnitMeasurements', true)}
        />
      );

    return null;
  };

  renderChartsContainer() {
    const { showWarningToMuchProducts, showMoreProductsSelected, showWarningNoGtin, usuario } = this.state;
    const { loadingProductDashboard, loadingProductDashboardTable, productDashboardList, productDashboardTableList, produto } = this.props;
    const userNotAllowed =
      usuario?.servicoPanel?.pacotePainel?.name === 'FREE' ||
      (usuario?.servicoPanel?.pacotePainel?.name === 'LIMIT' && produto?.cache.some(item => item.limited === true));

    return (
      <div className="infopanel-charts-container">
        <PanelProductSliderArea
          showWarningToMuchProducts={showWarningToMuchProducts}
          showMoreProductsSelected={showMoreProductsSelected}
          showWarningNoGtin={showWarningNoGtin}
          loadingProductDashboard={loadingProductDashboard}
          loadingProductDashboardTable={loadingProductDashboardTable}
          productDashboardList={productDashboardList}
          productDashboardTableList={productDashboardTableList}
          canDownload={userNotAllowed}
          onClickSeeAll={() => this.handleShowMoreProductsSelected(true)}
          onClickSeeLess={() => this.handleShowMoreProductsSelected(false)}
          onClickDownload={this.handleOnClickProductDashboardDownload}
          onClickTablePage={this.handleOnClickProductDashboardTablePage}
        />
        <LoadingSpinerArea area="download-infopanel" size="md" />

        <>
          {this.renderPlanTags()}
          {this.renderProductWarning()}
          {this.renderContentArea()}
        </>
      </div>
    );
  }

  renderEmptyState() {
    return (
      <FlexboxGrid>
        <FlexboxGrid.Item colspan={24}>
          <EmptyState
            title="Os produtos selecionados não possuem preço por unidade de medida"
            message="Tente novamente usando o preço pago ou regular. Para solicitar o cadastro de uma unidade de medida, contate a equipe de atendimento."
            image={noResultsImage}
          />
        </FlexboxGrid.Item>
      </FlexboxGrid>
    );
  }

  renderPanelContent() {
    const { showPainel } = this.state;
    const { productDashboardList, preco, totalDatapoints } = this.props;
    const datapoints = productDashboardList?.datapoints;
    const hasDatapoints = Array.isArray(datapoints) && datapoints.length > 0;
    const isEmptyDatapoints = Array.isArray(datapoints) && datapoints.length === 0;
    const isUnitMeasurePrice = preco?.name === 'PRECO_POR_UNIDADE_MEDIDA';

    if (!showPainel || totalDatapoints === 0) return null;
    if (hasDatapoints) return this.renderChartsContainer();
    if (isEmptyDatapoints && isUnitMeasurePrice) return this.renderEmptyState();

    return null;
  }

  render() {
    const {
      totalDatapoints,
      produto,
      dataInicio,
      showModalAnalisysPlan,
      showModalProductWithoutUnitMeasurements,
      productsWithoutUnitMeasurement,
      setPainelGeralState,
    } = this.props;
    const {
      errors,
      showPainel,
      columns,
      columnsValue,
      indeterminateColumn,
      checkAllColumn,
      showModalTrial,
      showModalDownload,
      showModalProdutosSemDetalhes,
      showModalPreviewDownloadPanel,
      columnsPreview,
      itensPreview,
      showBanner,
      usuario,
      showModalShareAnalyzedViews,
      fileDownloadStatusType,
    } = this.state;

    const userPlanType = usuario?.servicoPanelCliente?.pacotePainel?.description;

    const userNotAllowed =
      usuario?.servicoPanel?.pacotePainel?.name === 'FREE' ||
      (usuario?.servicoPanel?.pacotePainel?.name === 'LIMIT' && produto?.cache.some(item => item.limited === true));

    const isFree = usuario?.servicoPanel?.pacotePainel?.name === 'FREE';

    return (
      <Container className="main-container infopanel">
        <div id="container">
          <div className="infopanel-header-container">
            <Header
              title="InfoPanel"
              subtitle="Um ótimo resumo para entender o contexto dos preços!"
              badgeLabel={userPlanType}
              badgeClassName={getUserPlanType(userPlanType)}
            />
            {isFree ? <AnalisysCounter onClick={this.sendCTA} /> : null}
          </div>
          <FiltersArea
            getDashBoard={this.getIframe}
            validInput={this.validDateInput}
            errors={errors}
            usuario={usuario}
            onOpenCustomFilter={this.handleSearchFilter}
            onSearchCustomFilter={this.handleSearchFilter}
            onSearchProduto={this.handleFilterProduto}
            onOpenProduto={this.handleOnOpenProduto}
            onClickLoadMoreProduto={this.handleOnClickLoadMoreProduto}
          />
          <ResultsButtonArea
            columns={columns}
            showPainel={showPainel}
            userHasPermission={userNotAllowed}
            userIsLimit={usuario?.servicoPanel?.pacotePainel?.name === 'LIMIT'}
            disabledItemValues={disabledColumns(usuario?.tipoAdicionalContratos)}
            columnsValue={columnsValue}
            indeterminateColumn={indeterminateColumn}
            totalDatapoints={totalDatapoints}
            isShoppingBrasilColumn={isShoppingBrasilColumn}
            columnRef={ref => {
              this.picker = ref;
            }}
            checkAllColumn={checkAllColumn}
            onClickViewResults={this.getIframe}
            onChangeColumn={this.handleChangeColumn}
            onClickDownload={this.getPreview}
            onChangeCheckAll={this.handleCheckAllColumn}
            onClickColumnConfirm={() => {
              this.picker.close();
              this.confirmColumns();
            }}
            onClickShare={this.getShareTokensModal}
          />
          {showPainel && isFree ? <FixedBanner usuario={usuario} /> : null}
        </div>
        {this.renderProductUnitMeasurementWarning()}

        {this.renderPanelContent()}

        <ModalPreviewDownload
          show={showModalPreviewDownloadPanel}
          close={() => this.close('showModalPreviewDownloadPanel')}
          columnsPreview={columnsPreview}
          itensPreview={itensPreview}
          confirm={this.confirmDowload}
        />

        <ModalNoDetailsProducts
          show={showModalProdutosSemDetalhes}
          title="Produtos fora do contrato"
          subtitle="Os seguintes produtos estão fora da lista de produtos com detalhes disponíveis."
          close={() => this.close('showModalProdutosSemDetalhes')}
          produtos={produto?.cache?.filter(item => item.limited === true) || []}
        />
        <ModalNoDetailsProducts
          title="Produtos sem preço por unidade de medida"
          subtitle="Os seguintes produtos não possuem preço por unidade de medida, por isso, os dados destes produtos podem aparecer zerados."
          show={showModalProductWithoutUnitMeasurements}
          close={() => setPainelGeralState('showModalProductWithoutUnitMeasurements', false)}
          produtos={productsWithoutUnitMeasurement || []}
        />
        <ModalConfirm
          show={showModalDownload}
          modalWidth="490px"
          titleFontSize="16px"
          textAlign="center"
          footerAlign="center"
          closeButton={fileDownloadStatus[fileDownloadStatusType]?.closeButton}
          cancelButtonWidth={fileDownloadStatus[fileDownloadStatusType]?.cancelBtnWidth}
          confirmButtonWidth={fileDownloadStatus[fileDownloadStatusType]?.confirmBtnWidth}
          icon={fileDownloadStatus[fileDownloadStatusType]?.icon}
          title={fileDownloadStatus[fileDownloadStatusType]?.title}
          message={fileDownloadStatus[fileDownloadStatusType]?.message}
          confirmButton={fileDownloadStatus[fileDownloadStatusType]?.confirmButton}
          cancelButton={fileDownloadStatus[fileDownloadStatusType]?.cancelButton}
          onHide={() => this.close('showModalDownload')}
          onCancel={() => {
            this.setState({
              showModalDownload: false,
            });
          }}
          onConfirm={() => {
            this.setState({
              showModalDownload: false,
            });
          }}
        />
        <ModalNotification
          show={showModalTrial}
          onHide={() => this.close('showModalTrial')}
          title="Download"
          message={
            'Como você está em período de trial, cada download possui um limite de 10 linhas de dados. ' +
            'Ao contratar o InfoPrice Panel, você terá acesso completo aos preços de todas as lojas disponíveis.'
          }
          close={() => this.close('showModalTrial')}
        />
        <ModalBanner
          usuario={usuario}
          show={showBanner}
          onCancel={() => {
            this.setState({
              showBanner: false,
            });
          }}
        />
        <ModalShareAnalyzedViews
          show={showModalShareAnalyzedViews}
          onClickCopyLink={this.handleCopyLink}
          setShareEmailData={this.handleSendShareAnalysisLink}
          close={() => {
            this.setState({
              showModalShareAnalyzedViews: false,
            });
          }}
          deadlineDate={dataInicio && this.analysisDeadline()}
        />
        <ModalAnalisysPlan show={showModalAnalisysPlan} onCancel={this.handleOnCancelModalAnalisysPlan} onConfirm={this.sendCTA} />
      </Container>
    );
  }
}

const mapStateToProps = store => ({
  filtros: store.painelGeralDataReducer.filtros,
  filtrosAdicionados: store.painelGeralDataReducer.filtrosAdicionados,
  produto: store.painelGeralDataReducer.produto,
  rede: store.painelGeralDataReducer.rede,
  boxplotType: store.painelGeralDataReducer.boxplot.type,
  timeEvolutionType: store.painelGeralDataReducer.timeEvolution.type,
  timeEvolutionPeriodo: store.painelGeralDataReducer.timeEvolution.periodo,
  mapType: store.painelGeralDataReducer.map.type,
  shareTokens: store.painelGeralDataReducer.shareTokens,
  totalDatapoints: store.painelGeralDataReducer.totalDatapoints,
  loadingProductDashboard: store.painelGeralDataReducer.loadingProductDashboard,
  loadingProductDashboardTable: store.painelGeralDataReducer.loadingProductDashboardTable,
  productDashboardList: store.painelGeralDataReducer.productDashboardList,
  productDashboardTableList: store.painelGeralDataReducer.productDashboardTableList,
  tipoLoja: store.painelGeralDataReducer.tipoLoja,
  cnpj: store.painelGeralDataReducer.cnpj,
  fabricante: store.painelGeralDataReducer.fabricante,
  marca: store.painelGeralDataReducer.marca,
  conteudo: store.painelGeralDataReducer.conteudo,
  tipoProduto: store.painelGeralDataReducer.tipoProduto,
  secao: store.painelGeralDataReducer.secao,
  categoria: store.painelGeralDataReducer.categoria,
  mecanica: store.painelGeralDataReducer.mecanica,
  grupoMidia: store.painelGeralDataReducer.grupoMidia,
  midia: store.painelGeralDataReducer.midia,
  uf: store.painelGeralDataReducer.uf,
  cidade: store.painelGeralDataReducer.cidade,
  endereco: store.painelGeralDataReducer.endereco,
  regiao: store.painelGeralDataReducer.regiao,
  tipoPreco: store.painelGeralDataReducer.tipoPreco,
  origemPreco: store.painelGeralDataReducer.origemPreco,
  pmc: store.painelGeralDataReducer.pmc,
  rebaixaPreco: store.painelGeralDataReducer.rebaixaPreco,
  marcaPropria: store.painelGeralDataReducer.marcaPropria,
  dataInicio: store.painelGeralDataReducer.dataInicio,
  dataFim: store.painelGeralDataReducer.dataFim,
  raio: store.painelGeralDataReducer.raio,
  preco: store.painelGeralDataReducer.preco,
  canal: store.painelGeralDataReducer.canal,
  ad: store.painelGeralDataReducer.ad,
  showModalAnalisysPlan: store.painelGeralDataReducer.showModalAnalisysPlan,
  showModalSpeakWithSpecialist: store.painelGeralDataReducer.showModalSpeakWithSpecialist,
  userContratoLimiteData: store.painelGeralDataReducer.userContratoLimiteData,
  showModalProductWithoutUnitMeasurements: store.painelGeralDataReducer.showModalProductWithoutUnitMeasurements,
  productsWithoutUnitMeasurement: store.painelGeralDataReducer.productsWithoutUnitMeasurement,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setErro,
      setLimitProducts,
      getBoxPlotData,
      setSortColumnBoxplot,
      getTimeEvolutionData,
      getMapData,
      getMarkersData,
      getTopFiveData,
      getShareTokenData,
      getTotalDatapoints,
      getProductDashboardSlide,
      getProductDashboardTable,
      getItensFiltro,
      searchProdutos,
      setPainelGeralState,
    },
    dispatch,
  );

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InfoPanel));
